import React from "react";
import FormViewer from "../../components/FormViewer";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";
import { checkPermission, checkTextTranslation, checkTranslation, translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";

class AdminChangeBranchApplet extends React.Component {

    state = {
        errors: null,
        isPostingData: false,
    }

    componentDidMount() {
        // Initialize if needed
    }

    submitForm = () => {
        this.postValue()
    }

    postValue = () => {
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            
            if (data) {
                // Validate required fields
                if (!data.user || !data.applet || !data.newApplet) {
                    this.props.actions.addNotif({ 
                        type: 'error', 
                        title: translate('{{lang}}errors.invalidInputs'), 
                        description: translate('{{lang}}Please fill all required fields') 
                    })
                    return
                }

                this.setState({ isPostingData: true })
                
                // Convert changePermissions to boolean if it exists
                if (data.changePermissions !== undefined) {
                    data.changePermissions = Boolean(data.changePermissions)
                }

                HttpServices.request('changeBranch', data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ 
                            type: 'error', 
                            title: translate('{{lang}}errors.postDataFailed'), 
                            description: checkTranslation(fetchError.message) 
                        })
                        return
                    }
                    
                    // Show success message with details
                    let message = translate('{{lang}}Branch changed successfully')
                    if (fetchResult.info) {
                        if (fetchResult.info.recordsUpdated !== undefined) {
                            message += `. ${translate('{{lang}}Records updated')}: ${fetchResult.info.recordsUpdated}`
                        }
                        if (fetchResult.info.permissionsMigrated !== undefined) {
                            message += `. ${translate('{{lang}}Permissions migrated')}: ${fetchResult.info.permissionsMigrated}`
                        }
                    }
                    
                    this.props.actions.addNotif({ 
                        type: 'success', 
                        title: translate('{{lang}}Success'), 
                        description: message 
                    })
                    
                    // Reset form
                    if (this.form) {
                        this.form.resetForm()
                    }
                })
            }
        }
    }

    render() {
        if (!this.props.page) {
            return null
        }

        return (
            <Configurer
                settingsInfo={{ 
                    showFooter: true, 
                    showTabBar: true, 
                    showHeader: true, 
                    headerTitle: checkTextTranslation(this.props.page?.title), 
                    button: { goBack: false } 
                }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=""
            >
                <div className="container">
                    <div className="row m-0 w-100">
                        <div className="col-12 p-0 mb-3">
                            <div className="p-0" style={{ borderRadius: 0 }}>
                                <div className="flexc mt-4">
                                    <ProfileImage 
                                        width={54} 
                                        borderRadius={50} 
                                        notif={0} 
                                        border={'2px solid #eee'} 
                                        className={'mrd-3'} 
                                        data={{ image: this.props.page?.image ?? this.props.page?.icon }} 
                                    />
                                    <div className="">
                                        <p className="" style={{ color: '#0d172a', fontSize: "17px" }}>
                                            {checkTranslation(this.props.page?.title)}
                                        </p>
                                        <p className="mt-2" style={{ color: '#89a', fontSize: "12px" }}>
                                            {checkTranslation(this.props.page?.description)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-5 w-100 p-0">
                            <div className="w-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8, padding: '20px' }}>
                                <FormViewer 
                                    ref={el => this.form = el} 
                                    headers={this.props.page?.headers} 
                                    initData={null} 
                                    errors={this.state.errors} 
                                    inputClass={'modern-input'} 
                                    variables={this.props.variables} 
                                    openRefModal={this.props.openRefModal} 
                                    functionsHandler={this.props.functionsHandler} 
                                />
                                
                                <div className="flexc mt-4">
                                    {checkPermission(this.props.variables?.permissionRoot + '.create', false, this.props.applet) && (
                                        <div className="w-100">
                                            <LoaderButton
                                                onClick={this.submitForm}
                                                isLoading={this.state.isPostingData}
                                                text={checkTranslation('{{lang}}DoChange')}
                                                type={"Oval"}
                                                className="text-bold text-small text-uppercase w-100"
                                                buttonStyle={{ 
                                                    outline: 'none', 
                                                    width: '100%', 
                                                    backgroundColor: '#143e74', 
                                                    cursor: 'pointer', 
                                                    padding: '13px 20px', 
                                                    borderRadius: 8, 
                                                    textTransform: 'uppercase', 
                                                    fontSize: 15, 
                                                    fontWeight: 'bold', 
                                                    color: '#fff', 
                                                    border: 'none' 
                                                }}
                                                width={40}
                                                height={40}
                                                color="#143e74"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Configurer>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminChangeBranchApplet);

